import cn from 'classnames';
import { HTMLAttributes } from 'react';
import { useStore } from 'effector-react';
import { IBag } from '@@/bags/ts';
import { ISimpleMixingBag } from '@@/mixing/ts';
import { UiButton } from '@@/ui/components/ui-button';
import { $agricultureById } from '@@/agriculture/store/agriculture.store';
import { IAgriculture } from '@@/agriculture/ts';
import { AgricultureHintParameters } from '@@/agriculture/components/agriculture-hint-paramaters';
import { BagMainParameters } from '@@/bags/components/bag-main-parameters';
import { formatBagId } from '@lib/bag-formatting';
import { CrossIcon } from '@@/common/icons/cross.icon';
import { PenIcon } from '@@/common/icons/pens.icons';
import { useAsyncHandler } from '@@/common/hooks/use-async-handler.hook';
import { warehouseModel } from '@entities/warehouse';

import styles from './index.module.sass';

export function SimpleMixingBagCardBag(props: ISimpleMixingBagCardBagProps) {
  const {
    className,
    data,
    filled = false,
    onSelect,
    onEdit,
    onDelete,
    ...rest
  } = props;
  const rootClass = cn(className, styles.root, {
    [styles.root_bag]: !!data,
    [styles.root_select]: !data,
    [styles.root_filled]: filled,
  });

  const agricultureById = useStore($agricultureById);
  const culture = agricultureById[data?.agricultureId as number] as IAgriculture;
  const warehouses = useStore(warehouseModel.$allWarehouses);

  const { isLoading: isEditing, handler: onEditHandler } = useAsyncHandler({
    handler: onEdit,
  });
  const { isLoading: isDeleting, handler: onDeleteHandler } = useAsyncHandler({
    handler: onDelete,
  });

  return (
    <div className={rootClass} {...rest}>
      {!data && (
        <>
          <UiButton
            view="secondary"
            label="Выбрать источник"
            onClick={() => onSelect?.('bag')}
          />
          <UiButton
            view="clear"
            label="ввести вручную"
            size="s"
            onClick={() => onSelect?.('custom')}
          />
        </>
      )}

      {!!data && (
        <>
          <div className={styles.header}>
            <span className={styles.header__title}>
              {/* @ts-ignore */}
              {(warehouses.find((w) => w.id == data.warehouseId)?.name ||
                ('warehouseId' in data && data.warehouseId)) ??
                'Ручной ввод'}
            </span>
            <div className={styles.header__actions}>
              {filled && (
                <UiButton
                  className={styles.header__action}
                  view="clear"
                  iconRight={PenIcon}
                  onlyIcon
                  size="xs"
                  onClick={onEditHandler}
                />
              )}
              <UiButton
                className={styles.header__action}
                view="clear"
                iconRight={CrossIcon}
                onlyIcon
                size="xs"
                onClick={onDeleteHandler}
              />
            </div>
          </div>

          <div className={styles.info}>
            <span className={styles.info__culture}>{culture.name}</span>
            <span className={styles.info__id}>{data.id && formatBagId(data.id)}</span>
          </div>

          {/* @ts-ignore */}
          <AgricultureHintParameters params={data.values}>
            {/* @ts-ignore */}
            <BagMainParameters bag={data} />
          </AgricultureHintParameters>
        </>
      )}
    </div>
  );
}

export interface ISimpleMixingBagCardBagProps
  extends Omit<HTMLAttributes<HTMLDivElement>, 'children' | 'onSelect'> {
  data: IBag | ISimpleMixingBag | null;
  filled?: boolean;
  onSelect?: (type: 'bag' | 'custom') => void | Promise<void>;
  onEdit?: () => void | Promise<void>;
  onDelete?: () => void | Promise<void>;
}
